import {fetchMilestones} from '@github-ui/item-picker-milestone-tsq'
import {useQuery, useQueryClient} from '@github-ui/react-query'

export function useMilestoneQuery({
  owner,
  repo,
  milestone,
}: {
  owner: string | undefined
  repo: string | undefined
  milestone: string | undefined
}) {
  const queryClient = useQueryClient()

  return useQuery({
    queryKey: ['copilot-immersive-milestones', JSON.stringify(queryClient), owner, repo, milestone],
    queryFn: async () => {
      if (!owner || !repo || !milestone) return []

      const response = await fetchMilestones(queryClient, {
        owner,
        repo,
        query: milestone,
        count: 1,
      })
      return response.milestones
    },
  })
}
